export default __webpack_public_path__ + "static/media/ico-user-24.5269b19f.svg";